
import { Categorie } from "./Categorie";
import { Results } from "./Results";

export class GroupResults {
   code;
   categorie: Categorie;
   note: number;
   total_note: number;

   // tslint:disable-next-line:variable-name
   is_calc: boolean;
   results: Results[];

  public constructor(code, cat: Categorie, results:Results [], note, total_note){
    this.code = code ;
    this.note = note;
    this.total_note = total_note;
    this.results = results;
    this.is_calc = cat?.is_calc;
    this.categorie = cat;
  }
}
